/**
 * @generated SignedSource<<d9836655fa125ee2104a51cf8cf1df89>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type appTrello_viewer$data = {
  readonly id: string;
  readonly " $fragmentType": "appTrello_viewer";
};
export type appTrello_viewer$key = {
  readonly " $data"?: appTrello_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"appTrello_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appTrello_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "6d1242dca180403736a61074ba2f90c4";

export default node;
